import axios, {AxiosRequestConfig} from "axios";
import {api_host} from "../utils/constants";
import {configDefault} from "./post";

function get<ResponseType = any>(url: string, data?: any, cfg?: AxiosRequestConfig) {
  return axios.get<ResponseType>(
    api_host + '/' + url + (data ? '?' + Object
      .keys(data)
      .map(key => key + '=' + data[key])
      .join('&') : ''),
    {...configDefault(), ...cfg},
  );
}

export default get;
